module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4c8ef7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Marker.vue
// module id = 101
// module chunks = 1